module.exports = __webpack_public_path__ + "img/06_food3.e74761c7.png";